import styled, { css } from "styled-components";

export const LogoContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    margin-bottom: 15px;
  }
`;

export const SideBannerContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 250px;
  height: 100%;
  background: #000FFF;
  padding-top: 25px;
  transition: opacity 0.3s ease, transform 0.3s ease;

  > a {
    @media (max-width: 768px) {
      display: flex;
    }
  }

  svg {
    color: white;
    margin-bottom: 88.69px;
    height: 36.31px;
    width: 173.42px;
    path,
    .a {
      color: white;
      fill: white !important;
    }
  }

  @media (max-width: 769px) {
    padding: 25px 22.21px 15px 25px;
    max-width: 80%;

    svg {
      margin-bottom: 0px;
    }

    position: absolute;
    top: 0;
    left: -23px;
    width: 100%;
    max-width: ${({ showMenu }) => showMenu ? '90%' : '0'};
    opacity: ${({ showMenu }) => showMenu ? "1" : "0"};
    transform: ${({ showMenu }) => showMenu ? "translateX(0)" : "translateX(-100%)"};
    pointer-events: ${({ showMenu }) => showMenu ? "auto" : "none"};
    z-index: 30;
  }
`;

export const HeaderContainer = styled.header`
  display: none;
  flex-direction: column;
  color: white;
  margin-top: 20px;
  margin-bottom: 42px;

  span {
    color: white;
    font-size: 0.75rem;
    display: flex;
    align-items: center;
    svg {
      margin-left: -5px;
      margin-right: 4px;
      width: 20px;
      height: auto;
    }
  }

  h1 {
    color: white;
    font-size: 1.125rem;
    line-height: normal;
  }

  h2 {
    color: #c9dfff;
    font-size: 0.8125rem;
    line-height: normal;
  }

  @media (max-width: 768px) {
    display: flex;
  }
`;

export const Header = styled.header`
  display: none;
  flex-direction: column;
  color: white;
  margin-bottom: 42px;

  span {
    color: white;
    font-size: 0.75rem;
    display: flex;
    align-items: center;
  }

  h1 {
    color: white;
    font-size: 1.125rem;
    line-height: normal;
  }

  h2 {
    color: #c9dfff;
    font-size: 0.8125rem;
    line-height: normal;
  }

  @media (max-width: 768px) {
    display: flex;
  }
`;

export const MenuItemContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-top: 25px;
`;

export const SocialContainer = styled.div`
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);

  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 15px 30px 50px;
  flex-direction: row;
  padding-bottom: 30px;

  a + a {
    margin-left: 12px;
  }
`;

export const SocialIcon = styled.a`
  color: #fff;
  text-decoration: none !important;
  font-size: 1.25rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;

  &:hover {
    filter: brightness(0.7);
  }

  transition: 0.5s color;

  img {
    width: 27px;
    height: 27px;
  }
`;

export const MenuItemWrap = styled.div`
  border-left: 3px solid rgb(0, 255, 255);
  padding-left: 19px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;

  svg {
    color: rgb(0, 255, 255) !important;
    height: 24px;
    width: 24px;
    margin: unset;
  }
`;

export const MenuItemText = styled.span`
  font-size: 15px;
  font-weight: bold;
  color: rgb(0, 255, 255) !important;
  font-family: "Mangueira Bold";
`;

export const IconCloseWrap = styled.div`
  position: absolute;
  top: 8px;
  left: -35px;
`;
